export default __webpack_public_path__ + "static/media/scopus.54e28eb7.png";